var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    width: 505,
    height: 984,
    x: 0,
    y: -552
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14,21c-0.1,0-0.3,0-0.4-0.1C13.2,20.8,13,20.4,13,20v-5c0-0.6,0.4-1,1-1s1,0.4,1,1v2.8l6.5-5.8L15,6.2V9 c0,0.6-0.4,1-1,1s-1-0.4-1-1V4c0-0.4,0.2-0.8,0.6-0.9c0.4-0.2,0.8-0.1,1.1,0.2l9,8c0.2,0.2,0.3,0.5,0.3,0.7s-0.1,0.6-0.3,0.7 l-9,8C14.5,20.9,14.2,21,14,21z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1,21c-0.1,0-0.1,0-0.2,0C0.3,20.9,0,20.5,0,20C0,8.1,13.9,8,14,8c0.6,0,1,0.4,1,1c0,0.6-0.4,1-1,1 c-0.4,0-9.5,0.1-11.6,6.9C4.4,15.5,7.9,14,14,14c0.6,0,1,0.4,1,1s-0.4,1-1,1C3.9,16,1.9,20.3,1.9,20.4C1.8,20.8,1.4,21,1,21z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.0c72db4e3635146a255efc1ed0eb5b72.svg";
export { ForwardRef as ReactComponent };